<template lang="pug">
    div
      el-card(shadow='hover').card-collapse
        el-col(:span='8').center
          app-display(label="Nome do Interessado:", :content="vtn.processoSicarf.nomeRazaoSocialInteressado")
          app-display(label="Número do processo:", :content="vtn.processoSicarf.numeroProcesso")
        el-col(:span='8')
          app-display(label="CPF do Interessado:", :content="vtn.processoSicarf.cpfCnpjInteressado")
          app-display(label="Tipo de Processo:", :content="vtn.processoSicarf.tipo.nome")
      el-card(shadow='hover').card-collapse
        el-row(shadow='hover').card-collapse
          el-col(:span='4')
            app-display(label="Tipo:", :content="vtn.formaPagamento === 'A_VISTA' ? 'À vista' : 'À prazo'")
        el-row(shadow='hover').card-collapse
          el-col(:span='6')
            app-display(label="Valor principal:", :content="formatReal(vtn.calculosVtn.vtn)")
          el-col(:span='6')
            app-display(label="Valor desconto:",v-if="vtn.formaPagamento === 'PARCELADO'", :content="formatReal(vtn.calculosVtn.descontoTemDireito + vtn.calculosVtn.descontoRespeita)")
            app-display(label="Valor desconto:",v-if="vtn.formaPagamento === 'A_VISTA'", :content="formatReal(vtn.calculosVtn.descontoAVista)")
          el-col(:span='8')
            app-display(label="Valor total:", :content="formatReal(vtn.calculosVtn.vtnComDesconto || vtn.calculosVtn.vtn)")
        el-row(shadow='hover').card-collapse
          el-col(:span='6')
            app-display(label="Status da VTN:", :content="vtn.statusVtn")
          el-col(:span='6')
            app-display(label="Quantidades de DAEs emitidos:", :content="vtn.boletos.length")
          el-col(:span='8')
            app-display(label="Prazo de carência:", v-if="vtn.formaPagamento === 'A_VISTA' && vtn.statusVtn === 'Em aberto'", :content="vtn.prazoCarencia + ' dia(s)'")
            app-display(label="Quantidade de parcelas:", v-if="vtn.formaPagamento === 'PARCELADO'", :content="vtn.quantidadeParcelas")
        el-table.table-boletos(
          :data="dadosTabela",
          stripe
        )
          el-table-column(width="100" prop="numeroVia", label="Nº Via Dae" :formatter="formatNumeroVia")
          el-table-column(width="200" prop="dataCriacao", label="Data Emissão", :formatter="formatDataEmicao")
          el-table-column(width="200" prop="dataVencimento", label="Data Vencimento", :formatter="formatDataVencimento")
          el-table-column(prop="descricao", label="Receita", :formatter="formateReceita")
          el-table-column(prop="situacao", label="Status", :formatter="formatSituacao")
          el-table-column(prop="valor", label="Valor", :formatter="formatValor")
          el-table-column()
            template(slot-scope="scope")
              el-dropdown(trigger="click")
                el-button(type='primary', size="small")
                    | Ações
                    i.el-icon-arrow-down.el-icon--right
                el-dropdown-menu
                  el-dropdown-item(v-if="scope.row.situacao !== 'VENCIDO'")
                      div(@click="verificarPrazoDae(scope.row)", v-if="showEmitirDae(scope.row)")
                        i.fa.fa-dollar-sign.icon
                        | &nbsp Emitir DAE
                  el-dropdown-item(v-else)
                      div(@click="verificarPrazoDae(scope.row)", v-if="showEmitirDae(scope.row)")
                        i.fa.fa-dollar-sign.icon
                        | &nbsp Reemitir DAE
                  el-dropdown-item
                      div(@click="visualizarDae(scope.row)", v-if="showVisualizarDae(scope.row)")
                        i.fa.fa-eye
                        | &nbsp Visualizar DAE

      el-button(type="default", @click="voltar", icon="el-icon-arrow-left") Voltar
</template>

<script>

import AppDisplay from '@/components/AppDisplay'
import utils from '@/utils/utils'
import { mapActions } from 'vuex'
import AppNotificacao from '@/components/mixins/AppNotificacao'

export default {
  components: {
    AppDisplay
  },
  mixins: [
    AppNotificacao
  ],

  data () {
    return {
      active: 0,
      vtn: {
        calculosVtn: {},
        boletos: [],
        processoSicarf: {
          nomeRazaoSocialInteressao: '',
          cpfCnpjInteressado: '',
          numeroProcesso: '',
          tipo: {
            nome: ''
          }
        }
      },
      dadosTabela: [],
      parcelas: [],
      parcelasVtn: []
    }
  },

  async mounted () {
    await this.preencherDadosTabela()
    this.parcelas = await this.getParcelas(this.$route.params.idProcesso)
  },

  methods: {
    ...mapActions({
      getVtn: 'vtn/getVtnProcessoId',
      getParcelas: 'vtn/getParcelas',
      existsByParcela: 'dae/existsByParcela',
      getParcelasVtn: 'dae/getParcelasVtn',
      getBoleto: 'financeiro/findDaeByFilter'
    }),

    voltar () {
      this.$router.push({
        name: 'cof/gestaoVtn'
      })
    },

    formatValor (prop) {
      return `R$ ${utils.format(prop.valor ? prop.valor : prop.valorPrincipal)}`
    },

    formatReal (valor) {
      return `R$ ${utils.format(valor)}`
    },

    async preencherDadosTabela () {
      const data = await this.getVtn(this.$route.params.idProcesso)
      this.vtn = data

      this.parcelasVtn = await this.getParcelasVtn({ idVtn: this.vtn.id })

      if (this.vtn.boletos) {
        this.vtn.boletos.forEach(boleto => {
          if (!boleto.isReemitida) {
            this.dadosTabela.push(boleto)
          }
        })
      }

      // seta as parcelas que ainda não existem boletos
      if (this.parcelasVtn) {
        this.parcelasVtn.forEach(parcela => {
          if (!parcela.boleto) {
            this.dadosTabela.push(parcela)
          }
        })
      }

      // Trata a listagem para listar em ordem, de acordo com o numero da parcela e pelo id do boleto
      const objetosComParcela = this.dadosTabela.filter(obj => obj.numeroParcela)
      const objetosSemParcela = this.dadosTabela.filter(obj => !obj.numeroParcela)
      const objetosOrdenados = objetosSemParcela.concat(objetosComParcela)
      this.dadosTabela = objetosOrdenados

      for (let i = 0; i < this.dadosTabela.length; i++) {
        const prop = this.dadosTabela[i]
        const status = await this.getStatusBoletoSync(prop)
        const dataEmissao = await this.getDataEmissaoSync(prop)
        const dataVencimentoBoleto = await this.getDataVencimentoSync(prop)
        const dataVencimento = await this.formatDate(prop)
        const valor = await this.getValorSync(prop)
        this.$set(this.dadosTabela, i, { ...prop, situacao: status, dataEmissao: dataEmissao, dataVencimentoBoleto: dataVencimentoBoleto, valor: valor, dataVencimento: dataVencimento })
      }
    },
    async existsBoleto (prop) {
      const exists = await this.existsByParcela({
        processo: this.vtn.processoSicarf.id,
        referenciaParcela: prop.numeroParcela
      })
      return exists
    },

    async getStatusBoleto (prop) {
      let statusParcela = prop.situacao ? prop.situacao : 'AGUARDANDO_EMISSAO_BOLETO'

      try {
        if (prop.numeroParcela && prop.existeBoleto) {
          return await prop.boleto.situacao
        } else {
          return await statusParcela
        }
      } catch (error) {
        console.error('Ocorreu um erro:', error)
        return 'ERRO'
      }
    },

    async getValorSync (prop) {
      try {
        if (prop.numeroParcela && prop.existeBoleto && !prop.numeroParcela) {
          return prop.boleto.valorPrincipal
        } else {
          return prop.valor ? prop.valor : prop.valorPrincipal
        }
      } catch (error) {
        console.error('Erro na função getValorSync:', error)
        return 'ERRO'
      }
    },

    async getStatusBoletoSync (prop) {
      try {
        const status = await this.getStatusBoleto(prop)
        return status
      } catch (error) {
        console.error('Erro na função getStatusSync:', error)
        return 'ERRO'
      }
    },

    async getDataEmissaoSync (prop) {
      try {
        if (prop.descricao === `Total`) {
          return '-'
        }

        if (prop.numeroParcela && prop.existeBoleto) {
          return prop.boleto.dataCriacao ? new Date(prop.boleto.dataCriacao).toLocaleDateString('pt-BR') : '-'
        } else if (prop.dataCriacao) {
          return prop.dataCriacao
        } else {
          return '-'
        }
      } catch (error) {
        console.error('Erro na função getDataEmissaoSync:', error)
        return 'ERRO'
      }
    },
    async formatDate (prop) {
      if (prop.descricao === `Total`) {
        return '-'
      }
      if (prop.numeroParcela) {
        return new Date(prop.dataVencimentoDate).toLocaleDateString('pt-BR')
      } else if (prop.dataVencimento) {
        return prop.dataVencimento
      }
    },
    async getDataVencimentoSync (prop) {
      try {
        if (prop.descricao === `Total`) {
          return '-'
        }

        if (prop.numeroParcela && prop.existeBoleto) {
          return prop.boleto.dataVencimento ? new Date(prop.boleto.dataVencimento).toLocaleDateString('pt-BR') : '-'
        }
        return null
      } catch (error) {
        console.error('Erro na função getDataVencimentoSync:', error)
        return 'ERRO'
      }
    },

    formatSituacao (prop) {
      if (prop.descricao === `Total`) {
        return
      }
      if (prop.situacao !== 'QUITADO') {
        const data = Date.now()
        if (prop.dataVencimentoBoleto) {
          const partesDaData = prop.dataVencimentoBoleto.split('/')
          const dataBoletoVencimento = new Date(partesDaData[2], partesDaData[1] - 1, partesDaData[0])
          if (data > dataBoletoVencimento.getTime()) {
            prop.situacao = 'VENCIDO'
          }
        }
      }
      switch (prop.situacao) {
        case 'AGUARDANDO_PAGAMENTO':
          return 'Aguardando Pagamento'
        case 'QUITADO':
          return 'Pago'
        case 'CANCELADO':
          return 'Cancelado'
        case 'AGUARDANDO_EMISSAO_BOLETO':
          return 'Aguardando Emissão do boleto'
        case 'VENCIDO':
          return 'Vencido'
        default:
          return 'Aguardando Emissão do boleto'
      }
    },
    formateReceita (prop) {
      const parcela = prop.id ? this.parcelasVtn.find(p => p.boleto && p.boleto.id && p.boleto.id === prop.id) : null
      if (parcela) {
        return `${prop.receita.tipoReceita.descricao} ${(parcela.boleto.excedente ? ' (Referente ao excedente de área)' : '')}`
      } else if (prop?.receita?.referenciaParcela > 1) {
        const numeroParcelas = this.parcelasVtn.filter((p) => p?.boleto?.id === prop.id).filter(b => b?.boleto !== null || b?.boleto !== undefined).map((p) => p.numeroParcela)
        return `${prop.receita.tipoReceita.descricao} - Referente a parcel${numeroParcelas.length > 1 ? 'as' : 'a'} ${numeroParcelas.join(',')} `
      } else if (prop.numeroParcela) {
        return `${prop.numeroParcela}ª parcela`
      } else {
        return prop.receita.tipoReceita.descricao
      }
    },
    formatDataEmicao (prop) {
      if (prop.descricao === `Total`) {
        return
      } else if (prop.dataEmissao) {
        return prop.dataEmissao
      }
      return prop.dataCriacao ? prop.dataCriacao : '-'
    },
    formatDataVencimento (prop) {
      if (prop.descricao === `Total`) {
        return
      } else if (prop.dataVencimentoBoleto) {
        return prop.dataVencimentoBoleto
      }
      return prop.dataVencimento ? prop.dataVencimento : '-'
    },

    formatNumeroVia (prop) {
      if (prop.descricao === `Total`) {
        return
      }
      return prop.numeroVia ? prop.numeroVia : 0
    },
    emitirDae (parcela, isVencida) {
      this.$router.push({
        name: 'emitirDae',
        params: {
          idProcesso: this.vtn.processoSicarf.id,
          parcela: parcela,
          emitirDae: true,
          confirmarDados: true,
          visualizarDae: false,
          isVencida: isVencida
        }
      })
    },
    async verificarPrazoDae (parcela) {
      const prazoVencimento = new Date(utils.formatDateStringToJs(parcela?.dataVencimento))

      const dataHoje = new Date()
      prazoVencimento.setDate(prazoVencimento.getDate() + 150)
      parcela = {
        ...parcela,
        dataVencimento: new Date(utils.formatDateStringToJs(parcela.dataVencimento))
      }

      if (dataHoje < prazoVencimento) {
        this.emitirDae(parcela, false)
      } else {
        this.confirmBox(this.$messages.DAE_VENCIDA,
          this.$messages.TITULO_WARNING,
          async () => {
            this.emitirDae(parcela, true)
          },
          () => {
          }, 'Confimar', 'Cancelar')
      }
    },

    visualizarDae (parcela) {
      this.$router.push({
        name: 'emitirDae',
        params: {
          idProcesso: this.vtn.processoSicarf.id,
          emitirDae: false,
          confirmarDados: false,
          visualizarDae: true,
          parcela: parcela
        }
      })
    },
    showEmitirDae (prop) {
      if ((this.formatSituacao(prop) === 'Aguardando Emissão do boleto' || this.formatSituacao(prop) === 'Vencido') && !prop?.boleto?.isReemitida && !prop?.isReemitida) {
        return true
      }
      return false
    },
    showVisualizarDae (prop) {
      if (this.formatSituacao(prop) === 'Aguardando Pagamento' || this.formatSituacao(prop) === 'Vencido' || this.formatSituacao(prop) === 'Pago') {
        return true
      }
      return false
    }

  }
}
</script>

    <style scoped lang="scss">
    .card-collapse {
      border-radius: 10px;
      margin: 10px 0;
    }

    .label {
      font-weight: bold;
    }

    .table-boletos {
      width: 100%;
      margin: 20px 0;
    }

    .icon {
     margin: 0 5px;
    }
    </style>



// WEBPACK FOOTER //
// src/screens/analise/VisualizarDAEsGestaoVtn.vue